/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createDiscountCodeFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDiscountCode, serializeSetCodeActiveRequest, type DiscountCode, type ErrorResponse, type InternalErrorResponse, type SetCodeActiveRequest } from '../../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/campaigns/{campaignId}/codes/{discountCodeId}/active
 */
export interface ActiveRequestBuilder extends BaseRequestBuilder<ActiveRequestBuilder> {
    /**
     * A deactivated code stops unlocking its campaign: carts holding it report the code as inactive on their next change and checkout rejects them with that reason.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<DiscountCode>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: SetCodeActiveRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<DiscountCode | undefined>;
    /**
     * A deactivated code stops unlocking its campaign: carts holding it report the code as inactive on their next change and checkout rejects them with that reason.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: SetCodeActiveRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ActiveRequestBuilderUriTemplate = "{+baseurl}/api/campaigns/{campaignId}/codes/{discountCodeId}/active";
/**
 * Metadata for all the requests in the request builder.
 */
export const ActiveRequestBuilderRequestsMetadata: RequestsMetadata = {
    put: {
        uriTemplate: ActiveRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createDiscountCodeFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSetCodeActiveRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
